import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { ConfirmDeleteModalComponent } from "src/app/modules/core/components/delete-modal/confirm-delete-modal-component";
import { ArrayHelper } from "src/app/models/helpers/array-helper";
import { distinctUntilChanged, map } from "rxjs/operators";
import { combineLatest } from "rxjs";
export class AreasComponent {
    constructor(router, route, plantingSiteService) {
        this.router = router;
        this.route = route;
        this.plantingSiteService = plantingSiteService;
        this.plantingSiteAreas = [];
        // _areas: PlantingSiteAreaDto[] = [];
        // @Input("areas")
        // set areas(areas: PlantingSiteAreaDto[]) {
        //     this._areas = areas;
        //     this.sortByChanged();
        // }
        this.confirmDeleteMsg = "Are you sure you want to delete";
        this.columns = [
            { key: "areaNo", title: "Planting Area #", property: (areas) => areas.code },
            { key: "name", title: "Name", property: (areas) => areas.name },
            { key: "color", title: "Color", property: (areas) => areas.colorCode },
            { key: "year", title: "Year", property: (areas) => areas.year },
            { key: "kml", title: "KML", property: (areas) => areas.kmlUrl },
            { key: "flightPath", title: "Flight path", property: (areas) => areas.flightPathUrl },
        ];
        this.sortColumn = this.columns[0];
        this.sortAsc = true;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let sort$ = this.route.queryParamMap.pipe(map((map) => map.get("sort") || this.columns[0].key), distinctUntilChanged());
            let sortAsc$ = this.route.queryParamMap.pipe(map((map) => map.get("sortAsc") || "true"), distinctUntilChanged());
            combineLatest([sort$, sortAsc$]).subscribe(([sortKey, sortAsc]) => {
                let column = this.columns.find((value) => value.key == sortKey);
                if (column) {
                    this.sortColumn = column;
                }
                this.sortAsc = sortAsc === "true";
                this.sortByChanged();
            });
        });
    }
    delete(area) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
            if (result) {
                yield this.plantingSiteService.deletePlantingSiteArea(area.id);
                let index = this.plantingSiteAreas.findIndex((x) => x.id == area.id);
                this.plantingSiteAreas.splice(index, 1);
            }
        });
    }
    sortBy(column) {
        if (this.sortColumn == column) {
            this.sortAsc = !this.sortAsc;
        }
        else {
            this.sortColumn = column;
            this.sortAsc = true;
        }
        let sortKey = this.sortColumn.key;
        this.router.navigate([], {
            queryParamsHandling: "merge",
            replaceUrl: true,
            relativeTo: this.route,
            queryParams: { sort: sortKey, sortAsc: this.sortAsc },
        });
    }
    sortByChanged() {
        this.plantingSiteAreas = ArrayHelper.sortBy(this.plantingSiteAreas, this.sortAsc, this.sortColumn.property);
    }
}
